import React from 'react';
import ReactDOM from 'react-dom';
import GifApp from './components/GifApp';

import './index.css';

ReactDOM.render(<GifApp />, document.getElementById('root'));
